import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Image';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.00002 5.625C3.00002 5.21079 3.3358 4.875 3.75002 4.875H20.25C20.6642 4.875 21 5.21079 21 5.625V14.3858V18.375C21 18.7892 20.6642 19.125 20.25 19.125H3.75002C3.3358 19.125 3.00002 18.7892 3.00002 18.375V16.5L3 16.125L3.00002 15.5625V5.625ZM4.50002 16.3125V17.625H12.6207L7.5152 14.0511L4.50002 16.3125ZM15.2364 17.625H19.5V14.8151L15.4558 11.1386L11.3293 14.89L15.2364 17.625ZM10.0695 14.0081L7.93012 12.5106C7.66448 12.3246 7.30942 12.3304 7.05002 12.525L4.50002 14.4375V10.0295C4.92521 10.3261 5.4423 10.5 6.00002 10.5C7.44977 10.5 8.62502 9.32475 8.62502 7.875C8.62502 7.31728 8.45109 6.80019 8.15451 6.375H19.5V12.7879L15.9603 9.57004C15.6742 9.30998 15.2374 9.30999 14.9513 9.57005L10.0695 14.0081ZM6.00002 6.75C5.3787 6.75 4.87502 7.25368 4.87502 7.875C4.87502 8.49632 5.3787 9 6.00002 9C6.62134 9 7.12502 8.49632 7.12502 7.875C7.12502 7.25368 6.62134 6.75 6.00002 6.75Z" fill="currentColor"/>
  </svg>
`;

const ImageIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.00002 5.625C3.00002 5.21079 3.3358 4.875 3.75002 4.875H20.25C20.6642 4.875 21 5.21079 21 5.625V14.3858V18.375C21 18.7892 20.6642 19.125 20.25 19.125H3.75002C3.3358 19.125 3.00002 18.7892 3.00002 18.375V16.5L3 16.125L3.00002 15.5625V5.625ZM4.50002 16.3125V17.625H12.6207L7.5152 14.0511L4.50002 16.3125ZM15.2364 17.625H19.5V14.8151L15.4558 11.1386L11.3293 14.89L15.2364 17.625ZM10.0695 14.0081L7.93012 12.5106C7.66448 12.3246 7.30942 12.3304 7.05002 12.525L4.50002 14.4375V10.0295C4.92521 10.3261 5.4423 10.5 6.00002 10.5C7.44977 10.5 8.62502 9.32475 8.62502 7.875C8.62502 7.31728 8.45109 6.80019 8.15451 6.375H19.5V12.7879L15.9603 9.57004C15.6742 9.30998 15.2374 9.30999 14.9513 9.57005L10.0695 14.0081ZM6.00002 6.75C5.3787 6.75 4.87502 7.25368 4.87502 7.875C4.87502 8.49632 5.3787 9 6.00002 9C6.62134 9 7.12502 8.49632 7.12502 7.875C7.12502 7.25368 6.62134 6.75 6.00002 6.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: ImageIcon,
  IconSvg: IconSvg
} as IconType;
